import { api } from './client'

export interface TemplateSummary {
  id: string
  name: string
  domain: string
  description: string
  sessions: number
  riskExpectation: string
  expectForbiddenHint: boolean
  stepCount: number
}

export function fetchTemplates() {
  return api<{ templates: TemplateSummary[]; policyPacks: { id: string; active: boolean }[] }>(
    '/api/templates'
  )
}

export function applyTemplate(id: string) {
  return api<{
    success: boolean
    accepted: number
    patternsDetected: number
    patterns: { id: string; name: string; confidence: number }[]
  }>(`/api/templates/${id}/apply`, { method: 'POST', body: '{}' })
}
